import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconTextSize: React.FC<IconProps> = ({ width = 24, height = 24, color = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 25 24"
            fill="none"
        >
            <g clip-path="url(#clip0_10693_2668)">
                <path
                    d="M10.9453 3H15.4453V4.5H18.4453V0H0.445312V4.5H3.44531V3H7.94531V21H4.94531V24H13.9453V21H10.9453V3Z"
                    fill={color}
                />
                <path
                    d="M21.4453 12H24.4453L19.9453 7.5L15.4453 12H18.4453V18H15.4453L19.9453 22.5L24.4453 18H21.4453V12Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_10693_2668">
                    <rect width="24" height="24" fill="white" transform="translate(0.445312)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconTextSize;
